import { render, staticRenderFns } from "./collection_list.vue?vue&type=template&id=2cc7f79c&scoped=true"
import script from "./collection_list.vue?vue&type=script&lang=js"
export * from "./collection_list.vue?vue&type=script&lang=js"
import style0 from "./collection_list.vue?vue&type=style&index=0&id=2cc7f79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7f79c",
  null
  
)

export default component.exports